import {
  PlanType,
  RadioButtonGroupMapping,
  RadioButtonType,
} from '@labrav/react-components'
import { EulaType } from '../../../modules/privateOffer/types'

export const eulaStandardContractUrl =
  'https://assets.flyout.labra.io/standard_and_enterprise_eula/Standard-Contact-for-AWS-Marketplace-2022-07-14.pdf'

export const eulaButtonOptions: RadioButtonGroupMapping[] = [
  {
    key: EulaType.STANDARD,
    label: 'Standard contract for AWS marketplace',
    type: RadioButtonType.STANDARD,
    url: eulaStandardContractUrl,
  },
  {
    key: EulaType.CUSTOM,
    label: 'Custom EULA',
    type: RadioButtonType.STANDARD,
  },
]

export const getEulaOption = (productType: PlanType) => {
  if (productType === PlanType.SAAS_CONTRACT) {
    return eulaButtonOptions
  } else {
    return [
      {
        key: EulaType.PUBLIC,
        label: 'Public EULA',
        type: RadioButtonType.STANDARD,
      },
      ...eulaButtonOptions,
    ]
  }
}

export const renameFile = (originalFile: File, newName: string) => {
  return new File([originalFile], newName, {
    type: originalFile.type,
    lastModified: originalFile.lastModified,
  })
}

export const getEulaSectionConfig = (
  currentCloudProvider: string,
  isProductPlanTypeProfessionalService: boolean
) => {
  const isEulaSingleText =
    isProductPlanTypeProfessionalService || currentCloudProvider === 'AZURE'

  return {
    isEulaSingleText,
    eulaSubHeading: isEulaSingleText ? 'EULA' : 'EULA version',
    eulaTooltipLabel: isEulaSingleText
      ? 'Add your own custom EULA files.'
      : 'Select EULA or add your own custom EULA files.',
    eulaSectionHeading: `Service agreement${
      currentCloudProvider === 'AZURE' ? ' -optional' : ''
    }`,
    shouldShowEulaOptionSelectionRadioButtons:
      currentCloudProvider === 'AWS' && !isProductPlanTypeProfessionalService,
    eulaProps:
      currentCloudProvider === 'AZURE'
        ? {
            acceptedFormats: ['application/pdf'],
            acceptedFilesTextMsg:
              'Use plain text .pdf files only. Max file size 10 Mb',
          }
        : {},
  }
}
